module.exports = __webpack_public_path__ + "img/xuan.973d6aaf.png";